import { ICartData, ICartDataConfiguration, ICartDataConfigurationElement, IConfiguratorCreativeProduct, ICreativeData, ICreativeExtraData } from '@features/cart/typescript';

/** front-configurator ≥7.3.178 zwraca `extraData.name` jako string; starsze wersje jako `{ name }`. */
const resolveCreativeProductName = (extraData: ICreativeExtraData, data: ICreativeData): string => {
  const extraName = extraData.name;
  if (typeof extraName === 'string' && extraName.trim()) {
    return extraName.trim();
  }
  if (typeof extraName === 'object' && extraName?.name?.trim()) {
    return extraName.name.trim();
  }
  const dataWithName = data as ICreativeData & {
    name?: string;
  };
  if (dataWithName.name?.trim()) {
    return dataWithName.name.trim();
  }
  if (data.productPreset?.name?.trim()) {
    return data.productPreset.name.trim();
  }
  return '';
};
const productCreativeAdapter = (configuratorData: IConfiguratorCreativeProduct): ICartData[] => {
  const productType = 'CREATIVE';
  const cartData: ICartData[] = [];
  const productName = resolveCreativeProductName(configuratorData.extraData, configuratorData.data);
  const elements: ICartDataConfigurationElement = {
    availability: 1,
    count: 1,
    materialName: productName,
    name: productName,
    productId: configuratorData.extraData.objectUuid.uuid
  };
  const configuration: ICartDataConfiguration = {
    type: productType,
    productId: configuratorData.id,
    productName,
    thumb: configuratorData.extraData.images.main.CART,
    elements: [elements]
  };
  const product: ICartData = {
    productId: configuratorData.id,
    quantity: configuratorData.count,
    name: productName,
    image: configuratorData.extraData.images.main.FULL || null,
    configuration
  };
  cartData.push(product);
  return cartData;
};
export default productCreativeAdapter;